var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("משובים לוידאו: " + _vm._s(_vm.name)),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _vm.feedbacks
          ? _c(
              "table",
              { attrs: { id: "customers" } },
              [
                _vm._m(0),
                _vm._l(_vm.feedbacks.feedbacks, function (feedback) {
                  return _c("tr", { key: feedback.id, staticClass: "row" }, [
                    _c("td", { staticClass: "column-item" }, [
                      _vm._v(_vm._s(feedback.userName)),
                    ]),
                    _c("td", { staticClass: "column-item" }, [
                      _vm._v(_vm._s(_vm.parseDate(feedback.dateCreated))),
                    ]),
                    _c("td", { staticClass: "column-item" }, [
                      _vm._v(_vm._s(feedback.ratingNumber)),
                    ]),
                    _c("td", { staticClass: "column-item" }, [
                      _vm._v(_vm._s(feedback.ratingContent)),
                    ]),
                  ])
                }),
              ],
              2
            )
          : _vm._e(),
        _vm.feedbacks
          ? _c("div", [
              _vm._v(
                "דירוג ממוצע: " +
                  _vm._s(
                    Math.round((_vm.feedbacks.average + Number.EPSILON) * 100) /
                      100
                  )
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", [_vm._v("משתמש")]),
      _c("th", [_vm._v("תאריך")]),
      _c("th", [_vm._v("דירוג")]),
      _c("th", [_vm._v("תוכן")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }